import MONTH_NAMES from 'constants/date';

export const getDayWithOrdinal = (number: number): string =>
  `${number}${['st', 'nd', 'rd'][((((number + 90) % 100) - 10) % 10) - 1] || 'th'}`;

export const getOfferEndDate = (date: string): string => {
  const offerDate = new Date(date);
  const month = MONTH_NAMES[offerDate.getMonth()];
  const year = offerDate.getFullYear();
  let day = offerDate.getDate().toString();

  if (day.charAt(0) === '0') day = day.replace('0', '');
  return `${getDayWithOrdinal(+day)} ${month} ${year}`;
};

export const getEndAndStartDate = (startDate: string, endDate: string): string => {
  const startOfferDate = new Date(startDate);
  const startMonth = MONTH_NAMES[startOfferDate.getMonth()];
  const startYearyear = startOfferDate.getFullYear();
  const endOfferDate = new Date(endDate);
  const endMonth = MONTH_NAMES[endOfferDate.getMonth()];
  const endYearyear = endOfferDate.getFullYear();
  let startDay = startOfferDate.getDate().toString();
  let endDay = endOfferDate.getDate().toString();
  if (startDay.charAt(0) === '0') startDay = startDay.replace('0', '');
  if (endDay.charAt(0) === '0') endDay = endDay.replace('0', '');
  return `${getDayWithOrdinal(+startDay)} ${startMonth} ${startYearyear} - ${getDayWithOrdinal(
    +endDay,
  )} ${endMonth} ${endYearyear}`;
};
